import { getFetchedDataPayload } from '@vista-digital/utilities';
import { browsingDomainStore } from '../../store';
import { getSitesByIds } from './get-sites-by-ids';
export const getAllSites = () => {
    const siteIds = getFetchedDataPayload(browsingDomainStore.data.allSiteIds);
    return siteIds ? getSitesByIds(siteIds) : undefined;
};
//# sourceMappingURL=get-all-sites.js.map